import { useTranslation } from "react-i18next";

import vector from '../../img/Home/vector.png'

function Zitata () {

    const { t } = useTranslation();
      
    return(
        <div className="bg-[#1D1D1D] pt-[100px] xl:pt-[200px]">
            <div className="max-w-[1220px] bg-[#404040] xl:h-[275px] mx-[20px] md:mx-[40px] xl:mx-auto relative flex flex-col xl:flex-row justify-between p-[20px] xl:p-0 xl:px-[70px] items-center">
                <p className="xl:max-w-[415px] relative z-50 open-sans text-[14px] xl:text-[16px] text-[#F6F6F6] font-[300]">{t('home.add.8')}</p>
                <img src={vector} alt="" className="absolute top-0 xl:relative xl:pr-[100px] mt-[20px] w-[100px] xl:w-auto xl:mt-0"/>
            </div>
        </div>
    );
}

export default Zitata;